export const OPERATIONS = {
  path: 'operations',
  data: {
    breadcrumb: 'MENU_ADMIN.OPERATIONS',
    icon: 'pi pi-cog',
    clickable: false,
    openTab: true
  },
  maintenance: {
    path: 'maintenance',
    data: {
      breadcrumb: 'MENU_ADMIN.OPERATIONS_SUB.INCIDENTS_MAINTENANCE',
      icon: 'pi pi-exclamation-circle',
      openTab: true
    }
  },
  repairHistory: {
    path: 'repair-history',
    data: {
      breadcrumb: 'MENU_ADMIN.OPERATIONS_SUB.REPAIR_HISTORY',
      icon: 'pi pi-history',
      openTab: true
    }
  },
  reservations: {
    path: 'reservations',
    data: {
      breadcrumb: 'MENU_ADMIN.OPERATIONS_SUB.CALENDAR_SUB.EVENTS_RESERVATIONS',
      icon: 'pi pi-calendar-plus',
      openTab: true
    }
  },
  inventory: {
    path: 'inventory',
    data: {
      breadcrumb: 'MENU_ADMIN.OPERATIONS_SUB.INVENTORY_ASSETS',
      icon: 'pi pi-box',
      openTab: true
    }
  },
  moving: {
    path: 'moving',
    data: {
      breadcrumb: 'MENU_ADMIN.OPERATIONS_SUB.MOVING_DELIVERIES',
      icon: 'pi pi-truck',
      openTab: true
    }
  }
};

